<template>
  <PagesEducationHeadIntro :title="title" :description="description" />
  <PagesEducationInExample :example="example" />
  <PartialsTrackQrWidget />
  <PagesEducationSectionContent :contents="contents" />
  <PartialsAgencyCarousel />
</template>
<script lang="ts" setup>
import EducationLocale from "~~/config/widgets/for-education";
const education = new EducationLocale();
const example = education.example;
const title = education.title;
const description = education.description;
const contents = education.content;

import moment from "moment";
import DataLocale from "~~/config/interface/DataLocale";

const seoheader = new DataLocale([
  {
    locale: "en",
    title: "How QR Codes are Enhancing Learning and Teaching",
    description:
      "QR codes bring multimedia to education, enabling interactive learning through scanning for books, slideshows, Q&A, and display of work",
    keywords:
      "QR code learning,Interactive learning with QR codes,QR code technology in education,Mobile learning with QR codes,QR code resources for education,QR code multimedia in teaching,QR code textbooks,Innovative teaching with QR codes",
  },
  {
    locale: "fr",
    title: "Comment les QR codes améliorent l'apprentissage et l'enseignement",
    description:
      "Les QR codes apportent du multimédia à l'éducation, permettant un apprentissage interactif grâce à la numérisation de livres, diaporamas, questions-réponses et affichage de travaux",
    keywords:
      "apprentissage QR code, apprentissage interactif avec les QR codes, technologie QR code dans l'éducation, apprentissage mobile avec les QR codes, ressources QR code pour l'éducation, multimédia QR code dans l'enseignement, manuels QR code, enseignement innovant avec les QR codes",
  },

  {
    locale: "de",
    title: "Wie QR-Codes das Lernen und Lehren verbessern",
    description:
      "QR-Codes bringen Multimedia in die Bildung und ermöglichen interaktives Lernen durch Scannen von Büchern, Diashows, Q&A und Präsentation von Arbeiten",
    keywords:
      "QR-Code-Lernen, interaktives Lernen mit QR-Codes, QR-Code-Technologie in der Bildung, mobiles Lernen mit QR-Codes, QR-Code-Ressourcen für Bildung, QR-Code-Multimedia im Unterricht, QR-Code-Lehrbücher, innovatives Lehren mit QR-Codes",
  },

  {
    locale: "it",
    title: "Come i codici QR migliorano l'apprendimento e l'insegnamento",
    description:
      "I codici QR portano il multimedia all'istruzione, consentendo un apprendimento interattivo attraverso la scansione di libri, presentazioni, Q&A e la visualizzazione di lavori",
    keywords:
      "apprendimento QR code, apprendimento interattivo con i codici QR, tecnologia QR code nell'istruzione, apprendimento mobile con i codici QR, risorse QR code per l'istruzione, multimedia QR code nell'insegnamento, libri di testo QR code, insegnamento innovativo con i codici QR",
  },
  {
    locale: "es",
    title: "Cómo los códigos QR están mejorando el aprendizaje y la enseñanza",
    description:
      "Los códigos QR traen multimedia a la educación, permitiendo el aprendizaje interactivo a través de la exploración de libros, presentaciones de diapositivas, preguntas y respuestas, y la exhibición de trabajos.",
    keywords:
      "Aprendizaje con códigos QR, Aprendizaje interactivo con códigos QR, Tecnología QR en educación, Aprendizaje móvil con códigos QR, Recursos QR en educación, Multimedia QR en enseñanza, Libros de texto QR, Enseñanza innovadora con códigos QR",
  },
  {
    locale: "nl",
    title: "Hoe QR-codes het leren en onderwijzen verbeteren",
    description:
      "QR-codes brengen multimedia naar het onderwijs, waardoor interactief leren mogelijk is door te scannen voor boeken, diavoorstellingen, vragen en antwoorden en het tonen van werk.",
    keywords:
      "Leren met QR-codes, Interactief leren met QR-codes, QR-code technologie in het onderwijs, Mobiel leren met QR-codes, QR-code hulpmiddelen voor onderwijs, Multimedia QR in onderwijs, QR-code schoolboeken, Innovatief lesgeven met QR-codes",
  },
  {
    locale: "pt",
    title: "Como os códigos QR estão a melhorar a aprendizagem e o ensino",
    description:
      "Os códigos QR trazem multimédia para a educação, permitindo a aprendizagem interativa através da digitalização de livros, apresentações de diapositivos, perguntas e respostas e exibição de trabalhos.",
    keywords:
      "Aprendizagem com códigos QR, Aprendizagem interativa com códigos QR, Tecnologia QR na educação, Aprendizagem móvel com códigos QR, Recursos QR na educação, Multimédia QR no ensino, Livros escolares QR, Ensino inovador com códigos QR",
  },
  {
    locale: "vi",
    title: "Sử dụng mã QR để Nâng cao Quá trình Học Tập và Giảng Dạy",
    description:
      "Mã QR mang đến phương tiện đa phương tiện cho giáo dục, cho phép học tập tương tác thông qua quét cho sách, trình chiếu, câu hỏi và trả lời, và trưng bày công việc",
    keywords:
      "học tập với mã QR, học tập tương tác với mã QR, công nghệ mã QR trong giáo dục, học tập di động với mã QR, tài nguyên mã QR cho giáo dục, đa phương tiện mã QR trong giảng dạy, sách giáo khoa mã QR, giảng dạy đổi mới với mã QR",
  },
  {
    locale: "ja",
    title: "QRコード技術による学習と教育の向上",
    description:
      "QRコードは、書籍、スライドショー、Q&A、作品の表示に対してスキャンすることで、教育にマルチメディアをもたらし、インタラクティブな学習を可能にします。",
    keywords:
      "QRコード学習、QRコードによるインタラクティブ学習、教育におけるQRコード技術、QRコードを使ったモバイル学習、教育のためのQRコードリソース、QRコードマルチメディア教材、QRコード教科書、QRコードによる革新的な教育",
  },
  {
    locale: "zh",
    title: "应用QR码技术提高学习与教学效果",
    description:
      "QR码通过扫描书籍、幻灯片、问答、作品展示等多媒体教育资源，实现互动式学习，为教育带来了多媒体元素。",
    keywords:
      "QR码学习，QR码互动学习，QR码技术在教育中的应用，QR码移动学习，教育QR码资源，QR码多媒体教材，QR码教科书，QR码创新教育",
  },
]);

const datajd = useDataJd();
const meta = useMeta();

const i18nHead = useLocaleHead({
  addSeoAttributes: {
    canonicalQueries: ["/"],
  },
});
const meta_tags = meta.metaTag({
  title: seoheader.data.title,
  description: seoheader.data.description,
  url: datajd.currentURL(),
  image: datajd.assets("/images/og/education.jpg"),
});
useHead({
  title: seoheader.data.title,
  meta: [
    { name: "description", content: seoheader.data.description },
    { name: "keywords", content: seoheader.data.keywords },
    ...(i18nHead.value.meta || []),
    ...meta_tags,
  ],
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang,
  },
  link: [...(i18nHead.value.link || [])],
});
useSchemaOrg([
  defineWebPage({
    name: seoheader.data.title,
    datePublished: moment("2023-05-03").toISOString(),
    dateModified: moment().toISOString(),
    description: seoheader.data.description,
    inLanguage: datajd.inLanguages(true),
    url: datajd.currentURL(),
    image: datajd.assets("/images/og/education.jpg"),
  }),
  defineBreadcrumb({
    itemListElement: [
      {
        item: {
          "@id": datajd.currentHost(),
          name: "Home",
        },
      },
      {
        item: {
          name: "QR Codes in Education",
          "@id": datajd.currentHost() + useRoute().fullPath,
        },
      },
    ],
  }),
]);
</script>
